import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  backdrop-filter: blur(10px);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  width: 90%;
  max-width: 402px;
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;

  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transform: ${({ $isAnimating }) =>
    $isAnimating
      ? "translate(-50%, -50%) scale(1) translateY(0)"
      : "translate(-50%, -50%) scale(0.8) translateY(50px)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;
export const StyledRow = styled.div`
  display: flex;

  flex-direction: column;

  gap: 16px;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const ModalSubtitle = styled.p`
  color: #fff;

  font-family: DM Sans;
  font-size: 15px;

  font-weight: 400;
  opacity: 0.9;
  line-height: 20px; /* 133.333% */
`;

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid #1f1f22;
`;

export const SectionIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(0deg, #66033c -47.22%, #a3005e 100%);

  border: 1px solid #942160;
  background: #101010;
  box-shadow: 0 -1px 9.5px 0 #9b0859 inset;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  font-size: 20px;
  flex-shrink: 0;
`;

export const SectionContent = styled.div`
  flex: 1;
`;

export const SectionTitle = styled.h3`
  color: #fff;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;
`;

export const SectionDescription = styled.p`
  color: #fff;

  font-family: DM Sans;
  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  margin-bottom: 16px;
`;

export const SectionDescriptionFirst = styled.p`
  color: #fff;

  font-family: Figtree;
  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  margin-bottom: 5px;
`;

export const SectionDescriptionSecond = styled.p`
  color: #fff;
  opacity: 0.5;
  font-family: Figtree;
  font-size: 14px;

  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;

export const TimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const TimerLabel = styled.span`
  color: #fff;
  font-family: DM Sans;
  font-size: 16px;

  font-weight: 400;

  margin-top: 16px;
  letter-spacing: -0.4px;
`;

export const Timer = styled.div`
  font-size: 18px;
  font-weight: 700;
  padding: 12px 24px;
  font-family: DM Sans;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  width: fit-content;
  color: #a3005e;
`;

export const Divider = styled.div`
  height: 1px;
  background: #1b1b1d;
`;

export const ReferralLinkContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  gap: 16px;
`;

export const ReferralLink = styled.div`
  flex: 1;
  padding: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-family: DM Sans;

  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CopyButton = styled.button`
  cursor: pointer;
  transition: all 0.3s ease;
  justify-content: center;
  font-family: DM Sans;
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  background: #fff;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  @media (max-width: 450px) {
    align-self: flex-end;
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #1f1f22;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  width: ${(props) => props.$progress}%;
  height: 100%;
  /* background: linear-gradient(90deg, #a3005e, #c4057a); */
  background: #fff;
  border-radius: 4px;
  transition: width 0.5s ease;
`;

export const ProgressText = styled.span`
  color: #fff;
  font-family: DM Sans;
  font-size: 12px;
  text-transform: capitalize;
  font-weight: 400;
  line-height: 150%; /* 18px */
  letter-spacing: 0.06px;
`;

export const CollectButton = styled.button`
  display: ${(props) => (!props.$invite ? "flex" : "none")};
  height: 40px;
  flex-direction: row;
  padding: 9px 20px 9px 16px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 10px;

  border-radius: 100px;
  border: none;
  outline: none;
  background: #fff;

  color: #09090b;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.07px;

  cursor: pointer;

  &:disabled {
    color: white;
    cursor: not-allowed;
    background: #18181b;
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;
